import "./index.scss";
import { $, $all, forEach } from "@olmokit/dom";

/**
 * Component: BorderTop
 */
export function BorderTop() {
  console.log("BorderTop mounted.");

  const nav = $(".newmenu");
  if (!nav) return;

  const tabs = $all<HTMLButtonElement>(".newmenu-tab", nav);
  const dropdowns = $all<HTMLElement>(".newmenu-dropdown", nav);

  let hideTimer: ReturnType<typeof setTimeout> | null = null;

  function show(tabId: string) {
    cancelHide();
    forEach(tabs, (tab) => {
      const active = tab.dataset.tab === tabId;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-expanded", String(active));
    });
    forEach(dropdowns, (drop) => {
      drop.classList.toggle("is-visible", drop.dataset.for === tabId);
    });
  }

  function hide() {
    forEach(tabs, (tab) => {
      tab.classList.remove("is-active");
      tab.setAttribute("aria-expanded", "false");
    });
    forEach(dropdowns, (drop) => drop.classList.remove("is-visible"));
  }

  function scheduleHide() {
    hideTimer = setTimeout(hide, 100);
  }

  function cancelHide() {
    if (hideTimer !== null) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  forEach(tabs, (tab) => {
    tab.addEventListener("mouseenter", () => show(tab.dataset.tab!));
  });

  forEach(dropdowns, (drop) => {
    drop.addEventListener("mouseenter", () => { cancelHide(); show(drop.dataset.for!); });
    drop.addEventListener("mouseleave", scheduleHide);
  });

  nav.addEventListener("mouseleave", scheduleHide);
}
